"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UK_DEMOGRAPHICS = exports.SOCIAL_GRADE = exports.GEO = exports.INSURANCE_PRODUCTS_GB = void 0;
var question_1 = require("../../utils/question");
var types_1 = require("../types");
var common_1 = require("./common");
var INSURANCE_PRODUCTS_GB = function (t, languages, settings) {
    var value = types_1.DYNATA_QVALUE.INSURANCE_PRODUCTS_GB;
    var translateKey = types_1.DYNATA_TRANSLATION_KEYS[value];
    var options = [
        { value: '1', label: 'Personal Accident' },
        { value: '3', label: 'Automobile' },
        { value: '6', label: 'Health' },
        { value: '7', label: 'Building' },
        { value: '8', label: 'Life' },
        { value: '9', label: 'Personal Liability' },
        { value: '11', label: 'Travel' },
        { value: '12', label: 'None of the above' }
    ];
    return __assign(__assign({}, (0, common_1.getDefaultMultipleChoiceQuestion)(t, languages, translateKey, 'Insurance Products', value, options.length, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts))), { options: (0, question_1.getBuiltInOptions)(languages, options, t, translateKey, settings === null || settings === void 0 ? void 0 : settings.options, settings === null || settings === void 0 ? void 0 : settings.questionId) });
};
exports.INSURANCE_PRODUCTS_GB = INSURANCE_PRODUCTS_GB;
var GEO = function (t, languages, settings) {
    var value = types_1.DYNATA_QVALUE.GEO_GB;
    var translateKey = types_1.DYNATA_TRANSLATION_KEYS[value];
    var options = [
        { value: '1', label: 'East Midlands' },
        { value: '2', label: 'East of England' },
        { value: '3', label: 'Greater London' },
        { value: '4', label: 'North East England' },
        { value: '5', label: 'North West England' },
        { value: '6', label: 'Northern Ireland' },
        { value: '7', label: 'Scotland' },
        { value: '8', label: 'South East England' },
        { value: '9', label: 'South West England' },
        { value: '10', label: 'Wales' },
        { value: '11', label: 'West Midlands' },
        { value: '12', label: 'Yorkshire and the Humber' }
    ];
    return __assign(__assign({}, (0, common_1.getDefaultQuestion)(t, languages, translateKey, 'GEO - Region (UK)', value, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts), { geo: 'area' }
    // QTYPES.VECTOR_MAP
    )), { 
        // selectedRegion: {
        //     title: 'United Kingdom',
        //     label: 'United Kingdom',
        //     id: 'uk_regions_mill',
        //     value: 'uk_regions_mill',
        //     identifier: 'GB'
        // }
        options: (0, question_1.getBuiltInOptions)(languages, options, t, translateKey, settings === null || settings === void 0 ? void 0 : settings.options, settings === null || settings === void 0 ? void 0 : settings.questionId) });
};
exports.GEO = GEO;
var SOCIAL_GRADE = function (t, languages, settings) {
    var value = types_1.DYNATA_QVALUE.SOCIAL_GRADE_GB;
    var translateKey = types_1.DYNATA_TRANSLATION_KEYS[value];
    var options = [
        { value: '1', label: 'A - Upper Middle Class' },
        { value: '2', label: 'B - Middle Class' },
        { value: '3', label: 'C1 - Lower Middle Class' },
        { value: '4', label: 'C2 - Skilled Working Class' },
        { value: '5', label: 'D - Working Class' },
        { value: '6', label: 'E - Underclass' },
        { value: '7', label: 'Other' }
    ];
    return __assign(__assign({}, (0, common_1.getDefaultQuestion)(t, languages, translateKey, 'UK Social Grade', value, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts))), { options: (0, question_1.getBuiltInOptions)(languages, options, t, translateKey, settings === null || settings === void 0 ? void 0 : settings.options, settings === null || settings === void 0 ? void 0 : settings.questionId) });
};
exports.SOCIAL_GRADE = SOCIAL_GRADE;
var UK_DEMOGRAPHICS = function (t, languages, settings) { return [
    (0, common_1.GENDER)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.GB, settings),
    (0, common_1.HHR)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.GB, settings),
    (0, common_1.AGE)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.GB, settings),
    (0, common_1.PERSONAL_CARE_PRODUCTS)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.GB, settings),
    (0, common_1.LANGUAGE_FLUENCY)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.GB, settings),
    (0, common_1.FINANCIAL_PRODUCT)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.GB, settings),
    (0, common_1.HOUSEHOLD_CHILDREN)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.GB, settings),
    (0, common_1.VEHICLES_IN_HOUSEHOLD)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.GB, settings),
    (0, common_1.HOUSEHOLD_APPLICANCE_OWNED)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.GB, settings),
    (0, common_1.EMPLOYMENT_STATUS)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.GB, settings),
    (0, common_1.PETS_IN_HOUSEHOLD)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.GB, settings),
    (0, common_1.ENGINE_TYPE)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.GB, settings),
    (0, common_1.NUMBER_OF_CHILDREN)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.GB, settings),
    (0, common_1.NON_ALCOHOLIC_BEVERAGES)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.GB, settings),
    (0, common_1.PRIMARY_VEHICLES)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.GB, settings),
    (0, common_1.HOME_TYPE)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.GB, settings),
    (0, exports.INSURANCE_PRODUCTS_GB)(t, languages, settings),
    (0, exports.GEO)(t, languages, settings),
    (0, common_1.SEXUAL_ORIENTATION)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.GB, settings),
    (0, common_1.NUMBER_PPL_IN_HOUSEHOLD)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.GB, settings),
    (0, common_1.HOUSEHOLD_GROSS_INCOME)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.GB, settings),
    (0, common_1.RACE_ETHNICITY)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.GB, settings),
    (0, common_1.MARTIAL_STATUS)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.GB, settings),
    (0, common_1.HOUSEHOLD_INVESTABLE_ASSETS)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.GB, settings),
    (0, common_1.EDUCATION)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.GB, settings),
    (0, exports.SOCIAL_GRADE)(t, languages, settings)
]; };
exports.UK_DEMOGRAPHICS = UK_DEMOGRAPHICS;
//# sourceMappingURL=GB.js.map